<template>
  <v-dialog v-model="dialog" width="480" transition="fab-transition">
    <v-card class="pl-0 pr-0" style="height:100%; width: 100%;">
      <v-card-title style="height:20%">
        <v-icon class="mr-3">fas fa-lock</v-icon>
        <span class="description-selected">
          Nuevo analisis al detalle
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <div style="display: flex;">
        <v-col cols="12">
          <v-autocomplete
            ref="analisis_id"
            v-model="form.analisis_id"
            :items="analisisArrayAux"
            label="Analisis"
            outlined
            :item-text="customText"
            item-value="id"
            clearable
            :value="form.analisis_id"
            :loading="loading"
            v-on:keyup.enter="searchAnalysis($event)"
            @change="changeAnalisis()"
            hide-details="auto"
            required
          ></v-autocomplete>
          <!-- <v-autocomplete
            v-model="form.analisis_id"
            :items="analisisArrayAux"
            label="Analisis"
            hide-details
            outlined
            :item-text="customText"
            item-value="id"
            clearable
            @change="changeAnalisis()"
          ></v-autocomplete> -->
        </v-col>
      </div>

      <div style="display: flex;">
        <v-col cols="12" class="pt-3 pb-3">
          <v-text-field
            ref="name"
            v-model="form.name"
            :value="form.name"
            label="Nombre"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </div>

      <div style="display: flex;">
        <v-col cols="7">
          <v-autocomplete
            v-model="form.unit_medida_id"
            :items="units"
            label="Unidad de Medida"
            hide-details
            outlined
            :item-text="customText"
            item-value="id"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="3" class="" style="padding:0 15px;">
          <label>Dinamico</label>
          <v-btn-toggle
            v-model="form.is_dinamic"
            :value="form.is_dinamic"
            mandatory
            dense
            color="green darken-3"
            @change="handleTypeDinamic()"
            class="float-right"
          >
            <v-btn value="true" class="btn-show-mode" style="height:28px; ">
              SI
            </v-btn>
            <v-btn value="false" class="btn-show-mode" style="height:28px; ">
              NO
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </div>

      <div style="height:86vh;">
        <div class="pl-3 pr-3 ">
          <div class="" style="">
            <vue-editor
              class="table-editor table-edit"
              v-model="form.rango_referencial"
              placeholder="Rango Referencial"
            ></vue-editor>
          </div>
        </div>

        <div class="pl-3 pr-3 " style="margin-top: 140px;">
          <div class="" style="">
            <vue-editor
              class="table-editor table-edit"
              v-model="form.description1"
              placeholder="Descripcion 1"
            ></vue-editor>
          </div>
        </div>

        <div class="pl-3 pr-3 " style="margin-top: 140px;">
          <div class="" style="">
            <vue-editor
              class="table-editor table-edit"
              v-model="form.description2"
              placeholder="Descripcion 2"
            ></vue-editor>
          </div>
        </div>
      </div>

      <v-card-actions>
        <v-container class="pt-0 pb-0" style="height:115px;">
          <v-row style="padding-top:33px;">
            <v-col cols="6">
              <v-btn dark color="red" block @click="handleCancel">
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                dark
                color="green"
                block
                :disabled="processing"
                @click="handleSaveAnalysisService()"
              >
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- <create-update ></create-update> -->
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
// import { CreateUpdate } from "./CreateUpdate"

export default {
  name: "AddAnalysisDetail",
  props: ["devolverData"],
  components: {
    VueEditor,
    // CreateUpdate
  },
  data() {
    return {
      dialog: false,
      total_efectivo: null,
      processing: false,
      tillForm: {
        amount_cash: null,
        amount_card: null,
        amount_transfer: null,
        amount_yape: null,
      },
      total_amound_card: 0,
      form: {
        name: null,
        unit_medida_id: null,
        is_dinamic: "false",
        rango_referencial: null,
        analisis_id: null,
        description1: null,
        description2: null,
        is_compuesto: false,
        service_id_reference: null,
      },
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getAnalysisAux({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("tills", [
      "selected_till",
      "total",
      "total_cash",
      "total_card",
      "total_transfer",
      "total_yape",
    ]),
    ...mapState("analysis", [
      "analisisArray",
      "analisisArrayAux",
      "paginatedAux",
    ]),
    ...mapState("units", ["units"]),
  },
  methods: {
    ...mapActions("tills", ["storeOperation"]),
    ...mapActions("analysis", ["getAnalysisAux"]),
    customText(item) {
      let text = item.name;
      return text;
    },
    customTextDescription(item) {
      let text = item.description;
      return text;
    },
    async showDialog() {
      this.dialog = true;
      this.form = {
        name: null,
        unit_medida_id: null,
        is_dinamic: "false",
        rango_referencial: null,
        analisis_id: null,
        description1: null,
        description2: null,
        is_compuesto: false,
        service_id_reference: null,
      };
      await this.getAnalysisAux();
      this.loading = false;
      this.clearData();
    },
    clearData() {
      // ! limipar data

      this.clearErrors();
    },
    handleCancel() {
      this.clearData();
      this.dialog = false;
    },
    handleSaveAnalysisService() {
      const { name, unit_medida_id, is_dinamic, rango_referencial } = this.form;
      const {
        description1,
        description2,
        is_compuesto,
        service_id_reference,
      } = this.form;
      const unidadMedida = this.units.find((ut) => ut.id == unit_medida_id);
      const newItem = {
        unidadMedida,
        name,
        is_dinamic,
        rango_referencial,
        description1,
        description2,
        is_compuesto,
        service_id_reference,
      };
      this.devolverData(newItem);
      this.form = {
        name: null,
        unit_medida_id: null,
        is_dinamic: false,
        rango_referencial: null,
        description1: null,
        description2: null,
        is_compuesto: false,
        service_id_reference: null,
      };
      this.clearData();
      this.dialog = false;
    },
    handleTypeDinamic() {},
    existErrors() {
      let hasErrors = false;

      Object.keys(this.tillForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.tillForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.tillForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    changeAnalisis() {
      console.log(this.form.analisis_id);
      if (this.form.analisis_id) {
        const analisis = this.analisisArrayAux.find(
          (dt) => dt.id == this.form.analisis_id
        );
        this.form.unit_medida_id = analisis.unit_id;
        this.form.name = analisis.name;
        this.form.rango_referencial = analisis.rank;
        this.form.description1 = analisis.description1;
        this.form.description2 = analisis.description2;
        this.form.is_compuesto = analisis.iscompound ? true : false;
        this.form.service_id_reference = analisis.id;
      } else {
        this.form = {
          name: null,
          unit_medida_id: null,
          is_dinamic: "false",
          rango_referencial: null,
          analisis_id: null,
          description1: null,
          description2: null,
          is_compuesto: false,
          service_id_reference: null,
        };
      }
    },
    async searchAnalysis(event) {
      this.loading = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getAnalysisAux({ name: value });
      } else {
        await this.getAnalysisAux();
      }
      this.loading = false;
    },
  },
};
</script>

<style>
.table-edit {
  height: 90px;
}
</style>
